import axios from "axios";
import { req, reqF } from "./axiosFun";

// 分页获取供应商列表
export const getSupplyInfoPageList = (params) => {
	return reqF("post", "/api/sysConfig/Supply/GetSupplyInfoPageList", params);
};
// 保存供应商信息
export const saveSupplyInfo = (params) => {
	return reqF("post", "/api/sysConfig/Supply/SaveSupplyInfo", params);
};
// 删除供应商信息
export const deleteSupplyInfo = (params) => {
	return reqF("post", "/api/sysConfig/Supply/DeleteSupplyInfo", params);
};
// 获取供应商信息详情
export const getSupplyInfoDetail = (params) => {
	return reqF("post", "/api/sysConfig/Supply/GetSupplyInfoDetail", params);
};
// 获取所有供应商信息
export const getSupplyInfoList = (params) => {
	return reqF("post", "/api/sysConfig/Supply/GetSupplyInfoList", params);
};

// 分页获取客户信息
export const getCustomerInfoPageList = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerInfoPageList", params);
};
// 保存客户信息
export const saveCustomerInfo = (params) => {
	return reqF("post", "/api/sysConfig/Customer/SaveCustomerInfo", params);
};
// 删除客户信息
export const deleteCustomerInfo = (params) => {
	return reqF("post", "/api/sysConfig/Customer/DeleteCustomerInfo", params);
};
// 获取客户信息详情
export const getCustomerInfoDetail = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerInfoDetail", params);
};
// 获取所有客户信息
export const getCustomerInfoList = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerInfoList", params);
};
// 获取所有客户信息
export const GetCustomerList = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerList", params);
};
// 获取顾客和会员信息
export const GetCustomerVipInfo = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerVipInfo", params);
};
// 获取顾客和会员信息——通过顾客id
export const GetCustomerVipInfoByKeyId = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerVipInfoByKeyId", params);
};
// 顾客提成信息
export const GrantVipCommission = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GrantVipCommission", params);
};
// 分页获取顾客订单统计（30天周期内 >= 2 个加工订单的顾客）
export const getCustomerOrderStatisticPageList = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerOrderStatisticPageList", params);
};
// 初始化顾客订单统计（处理历史数据，幂等可重复执行）
export const initCustomerOrderStatistic = (params) => {
	return reqF("post", "/api/sysConfig/Customer/InitCustomerOrderStatistic", params);
};
// 获取所有客户信息——通过门店id
export const GetCustomerListByStore = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerListByStore", params);
};
//门店顾客数量统计
export const GetCustomerInfoStatistic = (params) => {
	return reqF("post", "/api/sysConfig/Customer/GetCustomerInfoStatistic", params);
};

// 分页获取商品类型信息列表
export const GetGoodsTypePageList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsTypePageList", params);
};
// 分页获取商品类型信息树级列表
export const GetGoodsTypeTreePageList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsTypeTreePageList", params);
};
// 获取全部商品类型树级数据
export const GetAllGoodsTypeTreePageList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetAllGoodsTypeTreePageList", params);
};
// 保存商品类型信息
export const SaveGoodsType = (params) => {
	return reqF("post", "/api/sysConfig/Goods/SaveGoodsType", params);
};
// 删除商品类型信息
export const DeleteGoodsType = (params) => {
	return reqF("post", "/api/sysConfig/Goods/DeleteGoodsType", params);
};
// 获取商品类型信息详情
export const GetGoodsTypeDetail = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsTypeDetail", params);
};
// 获取商品类型信息列表
export const GetGoodsTypeList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsTypeList", params);
};
// 设置商品类型是否上线
export const SetGoodsTypeIsOnline = (params) => {
	return reqF("post", "/api/sysConfig/Goods/SetGoodsTypeIsOnline", params);
};

// 获取商品参数信息列表
export const GetGoodsParamsPageList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsParamsPageList", params);
};
// 保存商品参数信息
export const SaveGoodsParams = (params) => {
	return reqF("post", "/api/sysConfig/Goods/SaveGoodsParams", params);
};
// 删除商品参数信息
export const DeleteGoodsParams = (params) => {
	return reqF("post", "/api/sysConfig/Goods/DeleteGoodsParams", params);
};
// 获取商品参数信息详情
export const GetGoodsParamsDetail = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsParamsDetail", params);
};
// 获取商品参数信息列表
export const GetGoodsParamsList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsParamsList", params);
};

// 分页获取商品信息列表
export const GetGoodsInfoPageList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsInfoPageList", params);
};
// 获取商品信息列表
export const GetGoodsInfoList = (params) => {
	return reqF("post", "/api/sysConfig/Goods/GetGoodsInfoList", params);
};
// 创建商品信息
export const CreateGoosInfo = (params) => {
	return reqF("post", "/api/sysConfig/Goods/CreateGoosInfo", params);
};
